<template>
  <div class="payment-methods-container">
    <div style="max-width: 400px">

      <div class="row" style="margin-top: 15px">
        <div class="col-12">
          <span class="sub-title">{{ $translation($websiteText().checkout_payment_method_account_holder) }}</span>
        </div>
      </div>
      <div class="row">
        <div class="col-10">
          <t-input-text
            name="account_holder"
            :id="'account_holder'"
            v-model="$store.getters.wireTransferInfo.account_name"
            :placeholder="$translation($websiteText().checkout_payment_method_account_holder)"
            style="width: 80%"
            :readonly="true"

          ></t-input-text>
        </div>
        <div class="col-2">
          <TButton
            style="float: right"
            :label=" 
              $translation($websiteText().checkout_payment_method_copy)
            "
            type="submit"
            color="primary-color"
            @click="
              copyTestingCode(
                $store.getters.wireTransferInfo.account_name,
                'account_holder'
              )
            "
          ></TButton>
        </div>
      </div>

      <div class="row" style="margin-top: 15px">
        <div class="col-12">
          <span class="sub-title">{{$translation($websiteText().checkout_payment_method_iban)}}</span>
        </div>
      </div>
      <div class="row">
        <div class="col-10">
          <t-input-text
            name="iban"
            v-model="$store.getters.wireTransferInfo.iban"
            :placeholder="$translation($websiteText().checkout_payment_method_iban)"
            style="width: 80%"
            :id="'iban'"
            :readonly="true"
          ></t-input-text>
        </div>
        <div class="col-2">
          <TButton
            style="float: right"
            :label=" 
              $translation($websiteText().checkout_payment_method_copy)
            "
            type="submit"
            color="primary-color"
            @click="copyTestingCode($store.getters.wireTransferInfo, 'iban')"
          ></TButton>
        </div>
      </div>

      <div class="row" style="margin-top: 15px">
        <div class="col-12">
          <span class="sub-title">{{$translation($websiteText().checkout_payment_method_transfer_reference)}}</span>
        </div>
      </div>
      <div class="row">
        <div class="col-10">
          <t-input-text
            name="transfer_reference"
            v-model="transferInfo.reference"
            :placeholder="$translation($websiteText().checkout_payment_method_transfer_reference)"
            style="width: 80%"
            :id="'reference'"
            :readonly="true"
           
          ></t-input-text>
        </div>
        <div class="col-2">
          <TButton
            style="float: right"
            :label=" 
              $translation($websiteText().checkout_payment_method_copy)
            "
            type="submit"
            color="primary-color"
            @click="copyTestingCode(transferInfo.reference, 'reference')"
          ></TButton>
        </div>
      </div>

      <div class="row" style="margin-top: 15px">
        <div class="col-12">
          <span class="sub-title">{{$translation($websiteText().checkout_payment_method_transfer_reference)}}</span>
        </div>
      </div>
      <div class="row">
        <div class="col-10">
          <t-input-text
            name="swift"
            v-model="$store.getters.wireTransferInfo.swift"
            :placeholder="'swift'"
            style="width: 80%"
            :id="'swift'"
            :readonly="true"
          ></t-input-text>
        </div>
        <div class="col-2">
          <TButton
            style="float: right"
            :label="
              $translation($websiteText().checkout_payment_method_copy)
            "
            type="submit"
            color="primary-color"
            @click="copyTestingCode(transferInfo.swift, 'swift')"
          ></TButton>
        </div>
      </div>

      <div class="row">
        <div class="col-10" style="width: 80%">
          <span style="color: red">
            {{ $translation($websiteText().checkout_payment_method_bank_transfer_sentence) }}
          </span>
        </div>
      </div>
      <div class="row" style="margin-top: 15px">
        <div class="col-12">
          <span class="sub-title">{{$translation($websiteText().checkout_payment_method_amout)}}</span>
        </div>
      </div>

      <div class="row">
        <div class="col-10">
          <t-input-text
            name="amount"
            v-model="transferInfo.amount"
            :placeholder="$translation($websiteText().checkout_payment_method_amount)"
            style="width: 80%"
            :id="'amount'"
            :readonly="true"
            
          ></t-input-text>
        </div>
        <div class="col-2">
          <TButton
            style="float: right"
            :label="
              $translation($websiteText().checkout_payment_method_copy)
            "
            type="submit"
            color="primary-color"
            @click="copyTestingCode(transferInfo.amount, 'amount')"
          ></TButton>
        </div>
      </div>

    </div>
    <div class="d-flex flex-column mb-2" style="margin-top: 15px" playwright-id="agree1">
      <t-checkbox
        v-model="transferInfo.agree1"
        name="agree"
        :label="$translation($websiteText().checkout_payment_method_waiting_for_availability_confirmation_checkbox)"
      />
    </div>
    <div class="d-flex f mb-2" style="margin-top: 15px" playwright-id="agree2">
      <t-checkbox v-model="transferInfo.agree2" name="agree" :label="$translation($websiteText().checkout_payment_method_agree)" />
      <div class="terms" @click="goToTerms()">{{$translation($websiteText().checkout_payment_method_terms_of_use)}}</div>
    </div>
    <div playwright-id="finalize-checkout">
      <TButton
        :disabled="!transferInfo.agree2 || !transferInfo.agree1 || !canPay"
        style="height: 38px; margin-top: 20px"
        :label="$translation($websiteText().checkout_payment_method_initiated_transfer_btn)"
        :icon="'pi pi-'"
        @click="paymentDoneAction"
        color="primary-color"
      ></TButton>
    </div>
  </div>
</template>

<script>
import TInputText from "../../../../../common/components/input-text/TInputText.vue";
import TButton from "../../../../../common/components/buttons/TButton.vue";
import TCheckbox from "../../../../../common/components/controls/TCheckbox.vue";
import {reactive} from "@vue/reactivity";
import {computed} from "@vue/runtime-core";
import store from "../../../../../store";
import GeneralHelper from "../../../../../common/helpers/GeneralHelper";
import Confirmation from "../Confirmation.vue";

import {
  CREATE_WIRETRANSFER_TRANSACTION,
  UPDATE_STEPPER,
  UPDATE_TRANSFER_INFO,
} from "../../../store/actions.js";
import GeneralVariables from "../../../../../common/utils/GeneralVariables";
export default {
  components: {TInputText, TButton, TCheckbox},
  props: {
    paymentDoneAction: Function,
    total: Number,
    currency: String,
  },
  mounted()
  {
    
  },
  setup(props) {
    let transferInfo = reactive({
      account_holder: "Topotrade.com",
      account_holder_copied: false,
      iban: "FR761234567891011121314",
      iban_copied: false,
      reference: GeneralHelper.makeIdFromNumber(store.getters.orderId, 5),
      reference_copied: false,
      amount: computed(() => {
        return props.currency.symbol + props.total;
      }),
      amount_int: computed(() => {
        return props.total;
      }),
      amount_copied: false,
      swift: "",
      swift_copied: false,
    });

    store.commit(UPDATE_TRANSFER_INFO, transferInfo);

    let copyTestingCode = (text, copied) => {
      let testingCodeToCopy = document.querySelector("#" + copied);
      let disabled = testingCodeToCopy.disabled
      testingCodeToCopy.disabled = false
      testingCodeToCopy.setAttribute("type", "text");
      testingCodeToCopy.select();

      try {
        var successful = document.execCommand("copy");
        testingCodeToCopy.disabled = disabled
        var msg = successful ? "successful" : "unsuccessful";
        transferInfo[copied + "_copied"] = true;
      } catch (err) {}

      /* unselect the range */
      window.getSelection().removeAllRanges();
    };

    let downloadInvoice = (id) => {
      window.open(GeneralVariables.BACKEND + "orders/" + id + "/invoice", "_blank");
    };

    let submit = () => {
      store.dispatch(CREATE_WIRETRANSFER_TRANSACTION, transferInfo.reference).then(() => {
        if (props.paymentDoneAction == undefined) {
          store.dispatch(UPDATE_STEPPER, ["confirmationDisplayActive"]);
          store.commit("checkoutActiveComponent", Confirmation);
          store.commit("clearCart");
          store.commit("setStepperDisplays", [0, 0, 0, 0, 0, 1]);
        } else {
          props.paymentDoneAction();
        }
      });
    };

    return {
      transferInfo,
      downloadInvoice,
      submit,
      copyTestingCode,
    };
  },

  computed: {
    canPay() {
      return this.$store.getters.status_id == 1;
    },
  },
  methods: {
    goToTerms() {
      let route = this.$router.resolve({
        name: "terms",
      });
      window.open(route.href, "_blank");
    },
  },
};
</script>

<style lang="scss">
.green-button {
  background: green !important;
}
.sub-title {
  @include f-label;
  color: black;
}
.copy-button {
  background: $grey !important;
  color: black !important;
}

.terms {
  @include f-button;
  cursor: pointer;
  text-align: flex-start;
  padding-left: 5px;
  text-decoration: underline !important;
  font-size: 15px;
}


</style>
